import React from 'react';
import { EditPage } from '@components/common';
import LocationForm from '@components/common/forms/LocationForm';

const LocationEditPage = () => {
    return (
        <EditPage
            modelName="locations"
            FormComponent={LocationForm}
        />
    );
};

export default LocationEditPage;
